@if (networkStatus() && isApiOk() && !maintenance()) {
  <router-outlet></router-outlet>
}

<app-lightbox></app-lightbox>
<app-toast-container></app-toast-container>

@if (!networkStatus() || !isApiOk() || maintenance()) {
  <div class="row vh-100">
    <div class="col-10 offset-1 offset-lg-3 col-lg-6 card my-auto py-5">
      @if (!networkStatus()) {
        <div class="text-center">
          <span class="offline-title">Internet connection required</span><br><br>
          <span class="offline-text">You're offline. Check your internet connection and try again.</span><br>
        </div>
      }

      @if (!isApiOk() && networkStatus() && !maintenance()) {
        <div class="text-center">
          <img src="assets/logo/logo.svg" height="96" alt="logo"><br><br>
          <span class="offline-title">KeyToCheck is currently unavailable</span><br><br>
          <span class="offline-text">Unable to communicate with KeyToCheck, please try again later.</span><br>
          <button class="btn btn-keytocheck w-50 mt-5" (click)="refresh()">
            @if (refreshing()) {
              <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            }

            <span>Retry</span>
          </button>
        </div>
      }

      @if (maintenance() && networkStatus()) {
        <div class="row">
          <div class="text-center">
            <img src="assets/logo/logo.svg" height="96" alt="logo"><br><br>
            <span class="text-center col-12 mt-4 offline-title">KeyToCheck is currently under maintenance</span><br><br>
            <span class="text-center col-12 offline-text" [innerHTML]="maintenance_msg()[userLang]"></span>
          </div>
        </div>
      }
    </div>
  </div>
}
